import globalStore from "@/store/global";
import globals from "@/utils/globals";
import { ISubscriber } from "@studyportals/event-aggregation-service-interface";
import { ProfileQuestionnairesAnswerChangedEvent, ProfileQuestionnairesReadyEvent, QuestionnaireType, QuestionType, RenderQuestionnaireCommand } from "@studyportals/profile-questionnaires-interfaces";
import { IProfileQuestionnairesApplication } from "@studyportals/profile-questionnaires-interfaces/profile-questionnaires-application.interface.";

export default class LeftContentContainer implements ISubscriber<ProfileQuestionnairesReadyEvent | ProfileQuestionnairesAnswerChangedEvent> {
	private profileQuestionnaireInstance?: IProfileQuestionnairesApplication;
	constructor(
		private emit: (action: 'notNow' | 'accept') => void,
	) {
		if (!globals.eventAggregationService) {
			document.addEventListener('AsyncEventAggregationServiceLoaded', () => {
				this.subscribeToEvents();
			});
			return;
		}

		this.subscribeToEvents();
	}

	private subscribeToEvents(): void {
		window['EventAggregationService'].subscribeTo(ProfileQuestionnairesReadyEvent.EventType, this, true);
		window['EventAggregationService'].subscribeTo(ProfileQuestionnairesAnswerChangedEvent.EventType, this, true);
	}

	public notify(event: ProfileQuestionnairesReadyEvent | ProfileQuestionnairesAnswerChangedEvent): void | Promise<void> {

		if (event.eventType === ProfileQuestionnairesReadyEvent.EventType) {
			this.profileQuestionnaireInstance = (event as ProfileQuestionnairesReadyEvent).profileQuestionnairesApplication;
		}

		if (event.eventType === ProfileQuestionnairesAnswerChangedEvent.EventType) {
			const { question } = event as ProfileQuestionnairesAnswerChangedEvent;
			if (question !== QuestionType.EMAIL_PREFERENCES) return;

			globals.cpiModalPlugin.renderCPIModal();
		}
	}

	public accept(): void {
		this.emit('accept');
	}

	public notNow(): void {
		this.emit('notNow');
	}

	public openNotificationSettings(): void {
		const command = new RenderQuestionnaireCommand(QuestionnaireType.NOTIFICATION_SETTINGS, true, true);

		this.profileQuestionnaireInstance!.renderQuestionnaire(command);
		globalStore.actions.dismissOptIn(true);
	}
}